var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatches(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Batches"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Batches",
    clipPath: "url(#clip-Batches)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1485",
    "data-name": "Group 1485",
    transform: "translate(12 12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M323.08,311.542l-19.7,19.7a13.924,13.924,0,0,1-9.851,4.081H182.061a13.921,13.921,0,0,1-9.852-4.084l-19.7-19.7a14.028,14.028,0,0,0-9.851-4.082H0V461.653a13.925,13.925,0,0,0,13.933,13.933H461.654a13.925,13.925,0,0,0,13.933-13.933V307.46H332.932A14.029,14.029,0,0,0,323.08,311.542Zm-57.42,79.517H209.927a13.933,13.933,0,0,1,0-27.866H265.66a13.933,13.933,0,0,1,0,27.866ZM307.46,0H168.128a13.925,13.925,0,0,0-13.933,13.933v28.8h167.2v-28.8A13.925,13.925,0,0,0,307.46,0ZM126.328,84.528v27.866H349.259V84.528A13.925,13.925,0,0,0,335.326,70.6H140.261A13.925,13.925,0,0,0,126.328,84.528ZM404.992,279.593h62.431l-62.431-61.5Zm-396.828,0H70.6v-61.5Z",
    fill: "#6e2b69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M106,164.933v125.4h44.194a41.79,41.79,0,0,1,29.547,12.237l15.628,15.63H295.3l15.628-15.629a41.79,41.79,0,0,1,29.547-12.237h44.194v-125.4A13.932,13.932,0,0,0,370.731,151h-250.8A13.932,13.932,0,0,0,106,164.933Zm55.733,13.933h167.2a13.933,13.933,0,0,1,0,27.867h-167.2a13.933,13.933,0,0,1,0-27.867Zm0,55.733h167.2a13.933,13.933,0,1,1,0,27.866h-167.2a13.933,13.933,0,0,1,0-27.866Z",
    transform: "translate(-7.538 -10.739)",
    fill: "#6e2b69"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatches);
export default __webpack_public_path__ + "static/media/Batches.35637171ccfe760e2706fb80a08d225a.svg";
export { ForwardRef as ReactComponent };